import { GetOrganizationCustomer } from "../queries/GetOrganizationCustomer.core.js";
export const getOrganizationCustomerByIdentifier = async ({ identifier }, { client }) => {
    const data = await client.core.request(GetOrganizationCustomer, {
        identifier,
    });
    if (!data?.customer) {
        throw new Error(`No customer found for identifier: ${identifier}`);
    }
    if (data?.customer?.__typename !== "Customer") {
        throw new Error(`Error getting organization customer by identifier: ${identifier}. ErrorName: ${data?.customer?.errorName}. Message: ${data?.customer?.message}`);
    }
    return data.customer;
};
